import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, UrlTree } from '@angular/router';
import { Observable, map } from 'rxjs';
import { AuthService } from '../../../services/auth.service';
import { LocalStorageService } from '../../../services/local-storage.service';
import { availableViews, LEADS_VIEW_STORAGE_KEY } from './leads-views';

/** Restores the chosen presentation only at the generic /leads entry. */
@Injectable({ providedIn: 'root' })
export class LeadsDefaultViewGuard implements CanActivate {
  constructor(
    private readonly router: Router,
    private readonly auth: AuthService,
    private readonly storage: LocalStorageService,
  ) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<UrlTree> {
    return this.auth.loadPermissions().pipe(map(() => {
      const views = availableViews(this.router.config, key => this.auth.hasPermission(key));
      const saved = this.storage.getItem(LEADS_VIEW_STORAGE_KEY);
      const view = views.find(entry => entry.id === saved) ?? views[0];
      return this.router.createUrlTree([view?.route ?? '/'], {
        queryParams: route.queryParams,
        fragment: route.fragment ?? undefined,
      });
    }));
  }
}
